<template >
  <v-col class="pa-0">
    <v-row
        v-if="isErrorCancel"
        no-gutters
        class="px-4 mt-4 mb-4"
      >
        <v-col>
          <span class="v-messages__message error--text">
            {{ $t('validation.dateRangeClosed') }}
          </span>
        </v-col>
      </v-row>

    <v-row
      no-gutters
      cols="12"
      class="px-4 mt-4 mb-4"
    >

        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="datetimeModel"
            :disabled="disabled"
            transition="scroll-y-transition"
            offset-y
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  readonly
                  v-model="datetimeModel"
                  :label="label"
                  prepend-icon="mdi-calendar"
                  persistent-hint
                  :style="{width: '11rem'}"
                  v-bind="attrs"
                  v-on="on">
                <template #append>
                  <v-icon
                    v-if="datetimeModel"
                    class="mr-2"
                    @click="clearDateTime"
                    style="cursor: pointer;"
                  >
                    mdi-close
                  </v-icon>
                </template>
              </v-text-field>
            </template>

          <div @click="handleDatetime">
            <v-date-picker
            v-model="dateModel"
            no-title
            scrollable
            :first-day-of-week="1"
            :locale="$i18n.locale"
            color="#27846d"
            :range="range"
            :hide-details="'auto'"
            >
            </v-date-picker></div>
        </v-menu>

    </v-row>
  </v-col>
</template>

<script>
import moment from 'moment';

const transformDate = function transformDate(date) {
  let transform;
  switch (date) {
  case 'today':
    transform = moment();
    break;
  case 'tomorrow':
    transform = moment().add(1, 'days');
    break;
  case 'yesterday':
    transform = moment().add(-1, 'days');
    break;
  default:
    return date;
  }
  return transform.format('YYYY-MM-DD');
};

export default {
  props: {
    label: String,
    params: {
      type: Object,
      default: () => ({}),
    },
    initialValue: {
      required: false,
    },
    sections: Object,
    required: {
      type: Boolean,
      default: () => false,
    },
    disabled: Boolean,
    changeOptions: Function,
  },
  data() {
    return {
      menu: false,
      datetimeModel: null,
      dateModel: null,
      timeModel: null,
      min: this.params.min ? transformDate(this.params.min) : null,
      max: this.params.max ? transformDate(this.params.max) : null,
      range: !!this.params.range,
      icon: typeof this.params.icon === 'string' ? this.params.icon : null,
      error: false,
      isErrorCancel: false,
    };
  },
  computed: {
    showTime() {
      return this.params.timepicker === 'true';
    },

  },
  methods: {
    openMenu() {
      setTimeout(() => { // waiting for input transition time
        if (!this.$refs.menu.isActive) {
          this.$refs.menu.isActive = true;
        }
      }, 150);
    },
    closeMenu() {
      this.$refs.menu.isActive = false;
    },
    formatDate(date, time) {
      const momentDate = moment(`${date} ${time || '00:00'}`,
        'YYYY-MM-DD HH:mm');
      let value;
      if (this.params.format) {
        value = momentDate.format(this.params.format);
      } else if (this.showTime) {
        value = momentDate.format('YYYY-MM-DD HH:mm');
      } else {
        value = momentDate.format('YYYY-MM-DD');
      }
      return value;
    },
    handleDatetime() {
      this.setDatetime(this.dateModel, this.timeModel);
    },
    clearDateTime() {
      if (!this.sections[0].fields[0].config.initialvalue.includes('CL')) {
        this.isErrorCancel = false;
        if (this.dateModel !== null) {
          this.datetimeModel = null;
          this.dateModel = null;
          this.timeModel = null;
          this.$emit('update:inputData', {});
          if (this.changeOptions) {
            this.changeOptions();
          }
        // @Change DateTime --> Funcion a realizar cuando se seleccione una fecha, si esta funciona se ha pasado por props
        // if (this.changeOptions) { this.changeOptions(); }
        }
      } else {
        this.isErrorCancel = true;
        // this.$store.dispatch('messages/createNotificationMessage', {
        //   title: this.$t('validation.dateRangeClosed'),
        //   type: 'warning',
        //   dismissible: true,
        //   timeout: this.$getConst('notifications.timeoutPlus'),
        // });
      }
    },
    disabledClosed(date) {
      const date1 = new Date(date[0]);
      const date2 = new Date(date[1]);
      const rango = (date1.getTime() - date2.getTime()) / (1000 * 3600 * 24);
      if ((rango !== null && rango < -90)
      && this.sections[0].fields[0].config.initialvalue.includes('CL')) {
        this.isErrorCancel = true;
        // this.$store.dispatch('messages/createNotificationMessage', {
        //   title: this.$t('validation.dateRangeClosed'),
        //   type: 'warning',
        //   dismissible: true,
        //   timeout: this.$getConst('notifications.timeoutPlus'),
        // });
        return false;
      }
      this.isErrorCancel = false;
      return true;
    },
    setDatetime(date, time) {
      if (date?.length > 1) {
        if (this.disabledClosed(date)) {
          try {
            const dates = (typeof date === 'string' ? [date] : date)
              .sort((d1, d2) => (moment(d1).isSameOrAfter(d2) ? 1 : -1))
              .map((d) => this.formatDate(d, time));
            const value = dates.join(' - ');
            this.$refs.menu.save(value);
            this.$emit('update:inputData', { value, item: dates });
            // @Change DateTime --> Funcion a realizar cuando se seleccione una fecha, si esta funciona se ha pasado por props
            if (this.changeOptions) { this.changeOptions(); }
            this.error = false;
            this.closeMenu();
            return value;
          } catch (err) {
            this.error = true;
            return undefined;
          }
        } else {
          this.error = false;
          this.closeMenu();
          return undefined;
        }
      } return null;
    },
  },
  created() {
    this.datetimeModel = null;
    this.dateModel = null;
    this.timeModel = null;
    this.$emit('update:inputData', {});
    /* eslint max-len: ["error", { "ignoreComments": true }] */
  /*
  const { initialValue } = this;
  if (typeof initialValue === 'string') {
      // only for filters
      if (initialValue.includes('::')) {
      this.datetimeModel = initialValue.split('::').map((k) => moment(k, 'YYYY-MM-DD').format('DD/MM/YYYY')).join(' - ');
      this.dateModel = initialValue.split('::');
      } else {
      const [date, time] = initialValue.split(' ');
      this.dateModel = transformDate(date);
      if (this.showTime) {
          this.timeModel = time;
      }
      this.datetimeModel = this.formatDate(this.dateModel, this.timeModel);
      this.$emit('update:inputData', { value: this.datetimeModel });
      }
  }
*/
  },
  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>

<style lang="scss">

// eslint-disable-next-line max-len
.theme--light.v-text-field--outlined.v-input--is-disabled {
  &:not(.v-input--is-focused):not(.v-input--has-state) {
    > .v-input__control > .v-input__slot:hover {
      cursor: initial;
      background: rgba(0, 0, 0, 0.06);
    }
  }
}

.error--text {
  color: #b64351 !important;
  caret-color: #b64351 !important;
  padding-top: 0px;
  margin-bottom: 8px;
  padding: 0 12px;
}

</style>
